export const formatMoney = (value?: number | string, currencyCode?: string) => {
  let formatter = Intl.NumberFormat('en', { notation: 'compact' })

  return `${formatter.format(Number(value))} ${currencyCode ?? ''}`
}
